<template>
    <div>
        <h3>
          {{ $t("home.widget.title") }}
          <div class="source-widget" :class="feedData.type">
            <div class="selected" @click="openMenuSources">{{ $t("home.widget.feed.news.text") }}</div>
            <ul @focusout="outsideMenuSourcesClick" tabindex="0" ref="sourcesList">
              <li class="title">{{ $t("home.widget.select.feed.title") }}</li>
              <li v-for="feed in feeds" :key="feed.type" @click="sourceSelected" :class="feed.type">
                {{ $t("home.widget.feed."+feed.type+".text") }}
              </li>    
            </ul>
          </div>
        </h3>
        <b-tabs content-class="mt-3" data-aos="fade-right" data-aos-delay="300">
          <b-tab :title="$t('home.widget.breakingnews')" active>
            <BreakingNewsWidget :news="news" :feedData="feedData" :loading="loading"/>
          </b-tab>
          <b-tab :title="$t('home.widget.list')">
            <NewsListWidget :news="news" :feedData="feedData" :loading="loading"/>
          </b-tab>
          <b-tab :title="$t('home.widget.live')">
            <NewsLiveWidget :news="news" :feedData="feedData" :loading="loading"/>
          </b-tab>
          <!--<b-tab title="Pied d'article">
            <NewsRowListWidget :news="news" :feedData="feedData" :loading="loading"/>
          </b-tab>-->
        </b-tabs>
    </div>
</template>

<script>

    import BreakingNewsWidget from './BreakingNewsWidget.vue'
    import NewsListWidget from './NewsListWidget.vue'
    import NewsLiveWidget from './NewsLiveWidget.vue'
    //import NewsRowListWidget from './NewsRowListWidget.vue'

    //var parser = new (require("rss-parser"))()
    const request = require('request');

    //const CORS_PROXY = "https://cors-anywhere.herokuapp.com/"
    //const CORS_PROXY = ""

    import configFeed from '../../config/widgetFeeds.js'

    export default {
        name: "WidgetExample",
         components: {
            BreakingNewsWidget,
            NewsListWidget,
            NewsLiveWidget,
            //NewsRowListWidget
        },
        data() {
            return {
                feeds: configFeed,
                feedData: configFeed[0],
                news: [],
                loading: false
            }
        },
        props: {
          reload: Boolean
        },
        watch: {
            reload: function () {
              document.body.querySelector( ".source-widget .selected").innerText = this.$t("home.widget.feed."+this.feedData.type+".text")
              this.initNews()
              this.reload = false
            }
        },
        mounted: function() {
            this.initNews()
        },
        methods: {
            async initNews() {   
              this.loading = true;

              const setNews = (news) => {
                this.news = news
                this.loading = false
              }

              request('https://api.saas.mashup-web.com/tools/parse-rss?url='+this.$t("home.widget.feed."+this.feedData.type+".url"), function (error, response, body) {
                
                if(error)
                  setNews([])
                else {  
                  body = JSON.parse(body)  
                  setNews(body.news)
                }
              });


              /*let returnedFeed = await parser.parseURL(CORS_PROXY+this.$t("home.widget.feed."+this.feedData.type+".url"));
              //let returnedFeed = await parser.parseURL(this.$t("home.widget.feed."+this.feedData.type+".url"));
              console.log('feeed', returnedFeed)
              this.news = returnedFeed.items
              this.loading = false;
              returnedFeed.items.forEach(item => {
                  console.log(item.title + ':' + item.link)
              });*/
            },
            openMenuSources: () => {
              document.body.querySelector( ".source-widget ul").classList.toggle("show");
              document.body.querySelector( ".source-widget ul").focus()
            },
            sourceSelected: async function(e) {
              if(this.feedData.type != e.target.className){
                this.feedData = configFeed.find(element => element.type == e.target.className)
                document.body.querySelector( ".source-widget .selected").innerText = this.$t("home.widget.feed."+e.target.className+".text")
                this.initNews()
              }
              document.body.querySelector( ".source-widget ul").classList.remove("show");
            },
            outsideMenuSourcesClick : () => {
              document.body.querySelector( ".source-widget ul").classList.remove("show");
            }
        }
    }
</script>

<style scoped>
  #widget h3 {
    color: #0cb2d5;
    text-align: center;
    font-size: 30px;
    margin-bottom: 25px;
  }
  .source-widget {
    display: inline-block;
  }
  .source-widget ul:focus {
    border: 0;
    outline: none;
  }
  .source-widget .selected {
    font-size: 25px;
    margin-top: 10px;
    display: inline-block;
    position: relative;
    padding-left: 25px;
    cursor: pointer;
  }
  .source-widget .selected:before {
    content: "";
    width: 15px;
    height: 15px;
    background: url(../../assets/double-arrow.svg) no-repeat;
    background-size: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 5px;
  }
  .source-widget ul {
    display: none;
  }
  .source-widget ul.show {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: #0cb2d5;
    color: #fff;
    width: 98%;
    max-width: 350px;
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
    margin: auto;
    margin-top: 10px;
    position: absolute;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
  }
  .source-widget ul li {
    font-size: 16px;
    cursor: pointer;
    padding: 8px 15px;
    width: 50%;
  }
  .source-widget ul li:first-child {
    background: #051b36;
    width: 100%;
    text-align: center;
  }
  .source-widget ul li img {
    width: 40px;
  }
  .source-widget.news ul li.news {
    display:none;
  }
  .source-widget.football ul li.football {
    display:none;
  }
  .source-widget.motors ul li.motors {
    display:none;
  }
  .source-widget.sports ul li.sports {
    display:none;
  }
  .source-widget.gossip ul li.gossip {
    display:none;
  }
  #widget .tabs {
    position: relative;
  }
  #widget .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  } 
</style>